import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@/components/ui/dialog";
import { AdminDialogHeading } from "@/components/admin/AdminDialogHeading";
import { WarningCircle } from "@phosphor-icons/react";

export function BlogDeleteDialog({
  isPending,
  onConfirm,
  onClose,
}: {
  isPending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog open onClose={onClose}>
      <DialogHeader onClose={onClose}>
        <AdminDialogHeading
          icon={WarningCircle}
          title="Obriši članak"
          description="Ova akcija se ne može poništiti."
          tone="destructive"
        />
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4">
        <p className="text-sm text-muted-foreground">
          Da li ste sigurni da želite obrisati ovaj članak?
        </p>
      </DialogBody>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          Otkaži
        </Button>
        <Button
          variant="destructive"
          disabled={isPending}
          onClick={onConfirm}
        >
          {isPending ? "Brisanje..." : "Obriši"}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
